<template>
  <div class="w-full">
    <NText variant="caption2" weight="regular" class="text-neutral-primary">
      <i18n-t
        scope="global"
        keypath="modules.portfolio.dividendDescription"
        tag="span"
      >
        <template #dividendValue>
          <NumberFormatter
            #="{ number }"
            :value="selectedSymbol.dividend"
            round="down"
          >
            {{ number }}
          </NumberFormatter>
        </template>

        <template #link>
          <a href="https://ddn.csdiran.ir" target="_blank">
            <NText variant="caption2" class="text-brand-primary underline">
              {{ t('modules.portfolio.stakeholdersPortal') }}
            </NText>
          </a>
        </template>
      </i18n-t>
    </NText>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { PortfolioItem } from '@libs/api-reference';
import { NText } from '@negar/core';

import NumberFormatter from '@/components/Number.vue';

type DividendDialogProps = {
  selectedSymbol: PortfolioItem;
};

defineProps<DividendDialogProps>();

const { t } = useI18n();
</script>
